var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBsdLeftDepth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 350,
    viewBox: "0 0 350 350",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_402_260)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M186.097 43.2495C186.097 43.2495 179.518 44.3057 179.518 50.8846C179.518 57.4635 186.097 57.9329 186.097 57.9329",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M943.643 70.8628V274.381H809.573C809.573 274.381 806.28 215.861 742.127 215.861C742.127 215.861 685.962 214.57 677.263 274.381V299.529H327.691H315.355",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.684 299.523V302.698L315.348 306.461H227.455V268.506C227.455 268.506 228.573 217.628 173.753 193.301C118.934 168.973 47.201 213.044 47.201 213.044L41.7336 222.033V244.945L45.7929 244.979L86.5019 245.297C86.5019 245.297 109.414 201.937 161.59 222.205C213.758 242.473 207.242 292.709 207.242 292.709C207.242 292.709 210.824 306.454 227.455 306.454",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6371 248.465H41.0365L25 253.926V280.014H65.5365C65.5365 280.021 76.9064 261.685 76.6371 248.465Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7405 222.033C41.7405 222.033 44.4743 218.774 58.6606 217.801V236.481C58.6606 236.481 52.9309 241.327 41.7405 241.942",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.019 247.409C601.019 247.409 597.318 252.959 595.731 260.277H241.105V247.409H601.019Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.158 253.843H595.731",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M863.643 212.333H241.106V206.521H863.643",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M863.643 179.025H241.106V165.805H863.643",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.158 172.411H859.059",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864.085 145.709H241.106V155.76H863.643",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.569 70.8628H337.697V145.716H249.569V70.8628Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.262 73.7417H333.99V106.346H253.262V73.7417Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.262 110.93H333.99V142.83H253.262V110.93Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M944.085 66.7485H182.804",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.441 42.0759V61.64H190.411V42.0759",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.411 61.64L189.617 64.6361H186.09V40.426H190.204V42.069H192.434C196.838 32.7288 205.122 30.4368 205.122 30.4368C230.768 20.3925 317.751 19.3293 317.751 19.3293H931.659C947.64 36.0769 943.643 70.856 943.643 70.856H182.804V56.8698",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.756 73.7417L232.156 86.3748V153.116H188.913L199.959 79.0849H212.177V73.7417H218.756Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.272 150.735H228.863V87.079L215.525 73.7417",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.959 79.0847L197.494 76.9723H193.497L191.426 80.1409H188.092V70.8628",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.178 81.4387V119.98H203.045C201.339 119.98 199.959 118.599 199.959 116.894V84.9042C199.959 82.992 201.512 81.4387 203.424 81.4387H212.178Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.178 123.384V140.773H204.011C201.774 140.773 199.959 138.958 199.959 136.721V126.966C199.959 124.985 201.56 123.384 203.542 123.384H212.178Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.141 151.611H186.711V156.112",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.959 126.966H196.666V162.809H204.246V157.576V156.637H198.606V133.725H199.959V126.966Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.246 157.576L212.474 160.931",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.48 160.931L209.713 165.218L211.356 166.571",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.713 165.218V168.566H220.054V158.639H209.713V160.047",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.666 126.967V85.4912H199.959",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.959 88.2524H198.316V110.93H199.959",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.959 112.987H198.316V126.966",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.666 156.112H173.753V193.301C173.753 193.301 161.327 195.682 161.59 222.205",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5928 138.309V172.853C66.5928 172.853 60.0691 170.029 55.8442 155.581C55.8373 155.581 55.1332 141.746 66.5928 138.309Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.753 156.112C173.753 156.112 90.8165 165.715 61.208 177.264C61.208 177.264 47.4634 179.556 47.2011 213.044",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5926 139.365H68.5325V170.388H66.5926",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6253 171.486V177.699L67.9458 181.02V190.042H65.357V182.373L61.3462 178.362V168.124",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.125 173.647V182.463",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.365 173.647V182.463",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.604 173.647V182.463",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.837 173.647V182.463",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.077 173.647V182.463",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.317 173.647V182.463",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.549 173.647V182.463",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.789 173.647V182.463",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.029 173.647V182.463",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.261 173.647V182.463",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.501 173.647V182.463",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.741 173.647V182.463",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.973 173.647V182.463",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.213 173.647V182.463",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.453 173.647V182.463",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.685 173.647V182.463",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.925 173.647V182.463",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.165 173.647V182.463",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.159 349.89C104.039 349.89 77.1893 323.04 77.1893 289.92C77.1893 256.8 104.039 229.951 137.159 229.951C170.279 229.951 197.128 256.8 197.128 289.92C197.128 323.04 170.279 349.89 137.159 349.89Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.159 346.735C105.781 346.735 80.3442 321.298 80.3442 289.92C80.3442 258.542 105.781 233.105 137.159 233.105C168.537 233.105 193.973 258.542 193.973 289.92C193.973 321.298 168.537 346.735 137.159 346.735Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.159 323.76C118.469 323.76 103.319 308.61 103.319 289.92C103.319 271.231 118.469 256.08 137.159 256.08C155.848 256.08 170.999 271.231 170.999 289.92C170.999 308.61 155.848 323.76 137.159 323.76Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.159 322.242C119.308 322.242 104.837 307.771 104.837 289.92C104.837 272.069 119.308 257.599 137.159 257.599C155.009 257.599 169.48 272.069 169.48 289.92C169.48 307.771 155.009 322.242 137.159 322.242Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.159 300.938C131.074 300.938 126.141 296.005 126.141 289.92C126.141 283.835 131.074 278.902 137.159 278.902C143.244 278.902 148.177 283.835 148.177 289.92C148.177 296.005 143.244 300.938 137.159 300.938Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.159 303.029C129.918 303.029 124.049 297.16 124.049 289.92C124.049 282.68 129.918 276.811 137.159 276.811C144.399 276.811 150.268 282.68 150.268 289.92C150.268 297.16 144.399 303.029 137.159 303.029Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.793 248.466V244.972",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9655 277.563L76.644 292.177",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.242 292.709H197.135",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.914 188.086C203.695 188.867 203.695 190.133 202.914 190.914L190.186 203.642C189.405 204.423 188.139 204.423 187.358 203.642C186.577 202.861 186.577 201.595 187.358 200.814L198.672 189.5L187.358 178.186C186.577 177.405 186.577 176.139 187.358 175.358C188.139 174.577 189.405 174.577 190.186 175.358L202.914 188.086ZM25.5858 190.914C24.8047 190.133 24.8047 188.867 25.5858 188.086L38.3137 175.358C39.0948 174.577 40.3611 174.577 41.1421 175.358C41.9232 176.139 41.9232 177.405 41.1421 178.186L29.8284 189.5L41.1421 200.814C41.9232 201.595 41.9232 202.861 41.1421 203.642C40.3611 204.423 39.0948 204.423 38.3137 203.642L25.5858 190.914ZM201.5 191.5L27 191.5L27 187.5L201.5 187.5V191.5Z",
    fill: "#2D9DC9"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.37114e-8,
    y1: 349.5,
    x2: 347,
    y2: 349.5,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206 183C206 181.895 206.895 181 208 181H230C231.105 181 232 181.895 232 183V197C232 198.105 231.105 199 230 199H208C206.895 199 206 198.105 206 197V183ZM218.527 197.677H219.476C219.712 197.677 219.903 197.485 219.903 197.25V193.752C219.903 193.517 219.712 193.325 219.476 193.325H218.527C218.291 193.325 218.099 193.517 218.099 193.752V197.25C218.099 197.485 218.291 197.677 218.527 197.677ZM219.476 186.681H218.527C218.291 186.681 218.099 186.489 218.099 186.249V182.752C218.099 182.516 218.291 182.325 218.527 182.325H219.476C219.712 182.325 219.903 182.516 219.903 182.752V186.254C219.903 186.489 219.712 186.681 219.476 186.681ZM211.738 190.903H215.244C215.48 190.903 215.672 190.712 215.672 190.476V189.529C215.672 189.294 215.48 189.103 215.244 189.103H211.738C211.502 189.103 211.31 189.294 211.31 189.529V190.476C211.31 190.712 211.502 190.903 211.738 190.903ZM222.332 190.472V189.525C222.332 189.289 222.523 189.098 222.759 189.098H226.266C226.502 189.098 226.693 189.289 226.693 189.525V190.472C226.693 190.707 226.502 190.898 226.266 190.898H222.759C222.523 190.898 222.332 190.707 222.332 190.472ZM213.225 195.094L213.898 195.765C214.067 195.934 214.339 195.934 214.504 195.765L216.985 193.29C217.155 193.121 217.155 192.85 216.985 192.685L216.313 192.014C216.143 191.845 215.872 191.845 215.707 192.014L213.225 194.49C213.06 194.654 213.06 194.925 213.225 195.094ZM222.3 187.988C222.136 188.157 221.864 188.157 221.694 187.988L221.022 187.317C220.852 187.152 220.852 186.881 221.022 186.712L223.503 184.237C223.668 184.068 223.94 184.068 224.109 184.237L224.782 184.908C224.951 185.072 224.951 185.343 224.782 185.512L222.3 187.988Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 189,
    x2: 22,
    y2: 360,
    stroke: "#2D9DC9",
    strokeWidth: 4,
    strokeDasharray: "8 8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_402_260"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 350,
    height: 350,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBsdLeftDepth);
export default __webpack_public_path__ + "static/media/bsdLeftDepth.1e948d7c34411f9048ca1a787850114b.svg";
export { ForwardRef as ReactComponent };